import Head from "next/head"
import { useSearchBox } from "react-instantsearch-core"

const SearchSeo = () => {
  const { query } = useSearchBox()
  return (
    <Head>
      <title>{`${
        query ? `${query} | Search Results` : "Search Books at gzb.ae"
      } | Largest Middle-East Bookstore | Millions of Titles`}</title>
      <meta
        name={"description"}
        content={
          "Discover a vast collection of books at gzb.ae, the largest Middle-East bookstore. Find millions of titles on various subjects, with next day delivery available throughout the UAE. Start your search today!"
        }
      />
      <meta
        key={"robots"}
        name={"robots"}
        content={"noindex"}
      />
      <meta
        key={"googlebot"}
        name={"googlebot"}
        content={"noindex"}
      />
    </Head>
  )
}

export default SearchSeo
